import {
  black,
  fadedBlack10,
  fadedBlack40,
} from '@backoffice-frontend/patterns'

export const serviceAreaBoundaryStyle = (hasDarkMode: boolean) => ({
  fillColor: hasDarkMode ? fadedBlack40 : fadedBlack10,
  lineWidth: hasDarkMode ? 2 : 1,
  strokeColor: black,
})
